module.exports = __webpack_public_path__ + "img/email-confirmation-failed.bc143a8a.svg";